import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hasValidNic: null,
  isResident: null,
  active: 1,
};

const welcomeReducer = createSlice({
  name: "welcomeReducer",
  initialState: initialState,
  reducers: {
    clearWelcomeReducer: () => initialState,
    setHasValidNic: (state, { payload }) => {
      return {
        ...state,
        hasValidNic: payload,
      };
    },
    setIsResident: (state, { payload }) => {
      return {
        ...state,
        isResident: payload,
      };
    },
    setActive: (state, { payload }) => {
      return {
        ...state,
        active: payload,
      };
    },
  },
});

export default welcomeReducer;
